import { AxiosResponse } from 'axios'

import ClientSDK from '../../ClientSDK'

import { IBatch, IBatchSetter } from './IBatch'

export class BatchClient {
  static delay = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  static handleBatchId = async (
    batchSetter: IBatchSetter,
    batchId: string,
  ): Promise<IBatch> => {
    const delayTime = [1000, 2000, 4000, 6000, 8000, 16000, 32000]
    let response: AxiosResponse<IBatch>

    for (let attempt = 0; attempt < 7; attempt++) {
      response = (await ClientSDK.instance().get(
        `batch/${batchId}`,
      )) as AxiosResponse<IBatch>

      if (response.data.data.status === 'processing') {
        batchSetter.setStatus(response.data.data.status)
        batchSetter.setProcessed(response.data.data.processed)
        batchSetter.setTotal(response.data.data.total)
        await new Promise(resolve => {
          setTimeout(resolve, delayTime[attempt])
        })
      } else if (response.data.data.status === 'finished') {
        return response.data
      }
    }

    batchSetter.setShowLoader(false)

    if (response?.data?.data?.status !== 'finished') {
      batchSetter.setFailedAttemptMessage(
        'Attempts to fetch data failed. Please refresh and try again.',
      )
    }

    return null
  }
}
